import 'owl.carousel';

// Notifications
$("#notifications").owlCarousel({
    items: 1,
    dots: false,
    loop: true,
    autoplay: true,
    margin:10,
});

// Home Slider Carousel
$(".hero_slider").owlCarousel({
    items: 1,
    dots: true,
    loop: true,
    autoplay: true,
    margin: 0,
    mergeFit: true,
    nav: false,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    autoplayHoverPause: true,
    responsive: {
        0: {
            items: 1
        },

        600: {
            items: 1
        },

        1024: {
            items: 1
        },

        1366: {
            items: 1
        }
    }
});

// Home Disease Carousel
$(".diseases").owlCarousel({
    items: 5,
    dots: true,
    loop: true,
    autoplay: true,
    margin: 20,
    mergeFit: true,
    responsive: {
        0: {
            items: 1,
            dots: false,
        },

        600: {
            items: 2
        },

        1024: {
            items: 3
        },

        1366: {
            items: 5
        }
    }
});
// Partners Carousel
$(".partners_slider").owlCarousel({
    items: 5,
    loop: true,
    autoplay: true,
    responsive: {
        0: {
            items: 1,
            dots: false,
        },

        600: {
            items: 2
        },

        1024: {
            items: 3
        },

        1366: {
            items: 5
        }
    }
});

// Home Testimonials Carousel
$(document).ready(function() {
    $(".testimonials_slider").owlCarousel({
        items: 1,
        dots: false,
        loop: true,
        autoplay: true,
        nav: true,
        margin: 0,
        mergeFit: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },

            600: {
                items: 1
            },

            1024: {
                items: 1
            },

            1366: {
                items: 1
            }
        }
    });
    $('.testimonials_slider .video_box').on('click', function () {
        $('.testimonials_slider').trigger('stop.owl.autoplay');
        var carousel = $('.testimonials_slider').data('owl.carousel');
        carousel.settings.autoplay = false; //don't know if both are necessary
        carousel.options.autoplay = false;
        $('.testimonials_slider').trigger('refresh.owl.carousel');
    });
});